import Page from 'modules/app/components/Page';
import s from '../ProductsByCategory/ProductsByCategory.module.scss';
import { useTypedSelector } from 'store/useTypedSelector';
import { useActions } from 'store/useActions';
import ShoppingCart from '../ShoppingCart';
import { useParams } from 'react-router-dom';
import { useState, useRef, useMemo, useEffect } from 'react';
import useIsAuth from 'sdk/hooks/useIsAuth';
import useGetAllProducts from 'sdk/hooks/shop/useGetAllProducts';
import useGetAllBrands from 'sdk/hooks/shop/useGetAllBrands';
import ProductCard from '../ProductsByCategory/ProductCard';
import ShopTopMenu from 'components/shared/ShopTopMenu';
import BrandFilter from '../ProductsByCategory/BrandFilter';
import useGetProductReviews from 'sdk/hooks/shop/useGetProductReviewsByProductId';
import useGetOrdersInTheCart from 'sdk/hooks/shop/useGetOrdersInTheCart';
import { useProductSorting } from 'sdk/hooks/shop/useProductSorting'; 

const AllProductsShop = () => {
  const { category } = useParams();
    const { setIsButtonMenuVisible } = useActions();
  const { data: isAuthData } = useIsAuth();
  const userId = isAuthData?.user?.id;
  const { isOpenBasket } = useTypedSelector(state => state.postSlice);
  const { setIsOpenBasket } = useActions();
  const { data: products } = useGetAllProducts();
  const { data: allReviews } = useGetProductReviews('*');
  const { data: cartData } = useGetOrdersInTheCart(userId);
  const { data: brands } = useGetAllBrands();
  const [showBrandsDropdown, setShowBrandsDropdown] = useState(false);
  const [selectedBrand, setSelectedBrand] = useState('All');

  const dropdownRef = useRef<HTMLDivElement>(null);

  const categories = {
    '1': 'All',
    '2': 'Top Rated',
    '3': 'Popular',
    '4': 'New Arrivals',
  };

  const sortedProducts = useProductSorting(products, category, allReviews, cartData);

  const filteredProducts = useMemo(() => {
    if (selectedBrand === 'All') return sortedProducts;

    return sortedProducts.filter(product => {
      const brandObj = brands?.find(b => b.id === product.brand);
      return brandObj?.name === selectedBrand;
    });
  }, [sortedProducts, selectedBrand, brands]);


    useEffect(() => {
      setIsButtonMenuVisible(true);
    }, []);
  
    
  return (
    <div style={{ overflow: 'auto' }}>
      <Page activeLink="/all-products-shop">
        <ShopTopMenu
          title={categories[category || '1']}
          onCartClick={setIsOpenBasket}
          backNavigationPath="/shop"
        />
        <div className={s.container}>
          {/* <div className={s.products_title}>{categories[category || '1']}</div> */}
          <BrandFilter
            selectedBrand={selectedBrand}
            setSelectedBrand={setSelectedBrand}
            showBrandsDropdown={showBrandsDropdown}
            setShowBrandsDropdown={setShowBrandsDropdown}
            brands={brands as Array<{ id: number; name: string }>}
          />
          <div className={s.grid}>
            {filteredProducts.map(item => (
              <ProductCard key={item.id} product={item} userId={userId} />
            ))}
          </div>
        </div>
      </Page>
      <ShoppingCart open={isOpenBasket} setOpenShoppingCartMenu={setIsOpenBasket} />
    </div>
  );
};

export default AllProductsShop;
